import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

// Shown on web (and as the initial value before the native lookup resolves).
// Native builds read the real CFBundleShortVersionString / versionName instead,
// so this only needs bumping for web releases.
export const WEB_APP_VERSION = '1.0.8';

let cached: string | null = null;

/** The running app's marketing version. Native reads it from the build via
 *  @capacitor/app; web falls back to WEB_APP_VERSION. */
export async function getAppVersion(): Promise<string> {
  if (cached) return cached;
  try {
    if (Capacitor.getPlatform() !== 'web') {
      const { App } = await import('@capacitor/app');
      cached = (await App.getInfo()).version;
      return cached;
    }
  } catch {
    /* fall through to web fallback */
  }
  cached = WEB_APP_VERSION;
  return cached;
}

/** React hook: the app version, resolved async (never stale vs the build). */
export function useAppVersion(): string {
  const [v, setV] = useState(cached ?? WEB_APP_VERSION);
  useEffect(() => {
    void getAppVersion().then(setV);
  }, []);
  return v;
}
